<template>
  <!-- Start Footer Area -->
  <footer class="footer-area bg-f7fafd">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget">
            <div class="logo">
              <a href="#"><img src="/img/logo.png" alt="logo"></a>
            </div>
            <p>{{ t('footer_about') }}</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget pl-5">
            <h3>{{ t('footer_company_title') }}</h3>
            <ul class="list">
              <li><a href="/article/?page=1">{{ t('footer_latest_news') }}</a></li>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget">
            <h3>{{ t('footer_support_title') }}</h3>
            <ul class="list">
              <li><a href="/page/privacy">{{ t('footer_privacy_policy') }}</a></li>
              <li><a href="/page/tos">{{ t('footer_privacy_tos') }}</a></li>
              <li><a href="/contact">{{ t('footer_contact_us') }}</a></li>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget">
            <h3>{{ t('footer_address_title') }}</h3>
            
            <ul class="footer-contact-info">
              <li><i data-feather="map-pin"></i> 15-22-301 Nakaochiai 3-Chōme, 161-0032 Shinjuku, Tokyo, Japan</li>
              <li><i data-feather="mail"></i> <a href="/contact">Contact us</a></li>
              <!-- <li><i data-feather="phone-call"></i> {{ t('footer_phone') }}: <a href="#">+ (81) 03-5223-8033</a></li> -->
            </ul>
            <ul class="social-links hide">
              <li><a href="#" class="facebook"><i data-feather="facebook"></i></a></li>
              <li><a href="#" class="twitter"><i data-feather="twitter"></i></a></li>
              <li><a href="#" class="instagram"><i data-feather="instagram"></i></a></li>
              <li><a href="#" class="linkedin"><i data-feather="linkedin"></i></a></li>
            </ul>
          </div>
        </div>

        <div class="col-lg-12 col-md-12">
          <div class="copyright-area">
            <p>© 2025 Karpeles Lab Inc. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>

    <img src="/img/map.png" class="map" alt="map">
    <div class="shape1"><img src="/img/shape1.png" alt="shape"></div>
    <div class="shape8 rotateme"><img src="/img/shape2.svg" alt="shape"></div>
  </footer>
  <!-- End Footer Area -->

  <div class="go-top"><i data-feather="arrow-up"></i></div>
</template>

<script>
import { onMounted } from 'vue'
import feather from 'feather-icons'
import i18next from '../i18next.js'

export default {
  name: 'SiteFooter',
  setup() {
    // Simple translation function
    const t = (key) => i18next.t(key);
    
    onMounted(() => {
      // Reinitialize Feather Icons
      feather.replace()
      
      // Go to Top functionality
      window.addEventListener('scroll', function() {
        const goTop = document.querySelector('.go-top')
        if (window.scrollY > 300) {
          goTop.classList.add('active')
        } else {
          goTop.classList.remove('active')
        }
      })
      
      document.querySelector('.go-top').addEventListener('click', function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })
    })
    
    return { t }
  }
}
</script>

<style scoped>
/* Footer styling is handled in the imported CSS */
</style>